<template>
    <div id="HvutInvoiceTemplate">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> FHUT Invoice Detail</div>
                    <div class="btn-groups text-right">
                        <button type="button" class="btn btn-primary" v-on:click="print()" > 
                            <i class="fp-print"> </i> Print
                        </button>
                        <button type="button" class="btn btn-primary" v-on:click="downloadPdf()" > 
                            <i class="fp-download"> </i> Download
                        </button>
                        <button type="button" class="btn btn-secondary" v-on:click="backBtn()" > 
                            <i class="fp-back"> </i> Back
                        </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content hvut-invoice-preview">
                        <section class="bg-white">
                            <div class="invoice-view-table" id="print_content">
                            </div>
                        </section>
                    </div>                
                </div>    
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>    
        </div>    
    </div>        
</template>
<script>
import Vue from 'vue';


import {commonMixins} from '../../mixins/commonMixins';


export default {
    name: "HvutInvoiceTemplate",
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: "Customer Invoice Preview | " +process.env.COPYRIGHT_NAME
    },
    
    mixins:[commonMixins],
    data: () => ({
        invoiceArr:[],
        loading:false,
        permissions:[],
        cantAccessPage:"",        
        invoiceId : 0,
        path:"",
        invoice_number:'',
        invoice_date:'',
        due_date:'',
        customer:'',
        terms:'',
        po_no:'',
        invoice_type:'',
        sub_total:'',
        tax_amount:'',
        total:'',
        invoiceItemsArr:[],
        cust_code:'',
        cust_name:'',

    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'view_invoice') {
                    self.cantAccessPage = true;
                }
            });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        }
    },
    mounted: function() {
        var self = this;
        self.invoiceId = this.$route.params.id;
        self.getPermissions();
        self.previewInvoice();
        self.path = process.env.API +  "/images/logo.png";
    },
    methods : {
        backBtn(){
            var self = this;
            self.$router.push("/invoice/fhut/"+self.invoiceId);            
        },
        loadInvoiceData() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/invoice-hvut/view",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{'invoice_id':self.invoiceId},
                success: function (data) {
                    self.loading = false;
                    
                    if (data.status == "success") {
                        self.invoice_number = data.content.invoice_number;
                        self.customer = data.content.customer;
                        self.cust_code = data.content.cust_code;
                        self.cust_name = data.content.cust_name;
                        self.invoice_date = data.content.invoice_date;
                        self.due_date = data.content.due_date;
                        self.invoice_status = data.content.status;
                        if (data.content.cpo_number != null) {
                            self.po_no = data.content.cpo_number;
                        }else{
                            self.po_no = "-";    
                        }
                        if (data.content.term_name != null) {
                            self.terms = data.content.term_name+' '+data.content.term_period;
                        }else{
                            self.terms = "-";    
                        }                        
                        self.invoice_type = data.content.invoice_type;
                        self.sub_total = data.content.sub_total;
                        self.tax_amount = data.content.tax_amount;
                        self.total = data.content.total;
                        if (data.content.items != undefined) {
                            self.invoiceItemsArr = data.content.items;
                        }else{
                            self.invoiceItemsArr = [];
                        }
                    } 
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'hvut-invoice-view-detail');
                }
            });
        },
        downloadPdf() {
            var self = this;
            self.loading = true ;
            $.ajax({
                url: process.env.ROOT_API + "/invoice/pdf",
                type: "POST",
                data: {
                    invoice_id:self.invoiceId,
                    invoice_type:"HV",
                    invoice_origin:"system"
                },
                headers: this.ajxHeaders,
                dataType: 'json',
                success: function (data) {
                    self.loading = false ;
                    if (data.status == 'success'){
                        var link = document.createElement('a');
                        document.body.appendChild(link);
                        link.href = data.content;
                        link.download = '';
                        link.target = "_blank";
                        link.click();
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'download-hvut-invoice');
                }
            });

        },
        previewInvoice() {
            var self = this;
            self.loading = true;
            $.ajax({
                // url: process.env.ROOT_API + "/invoice-permit/view",
                url: process.env.ROOT_API + "/hvut-invoice/preview",
                type: "GET",
                crossDomain: true,
                headers: this.ajxHeaders,
                data:{invoice_id:self.invoiceId,from:'preview'},
                dataType: "json",
                success: function(data) {
                    self.loading = false;
                    setTimeout(function(){
                        $("#print_content").html("");
                        $("#print_content").html(data.view);
                    },200);
                    
                    //var content = data;
                    //$( "div.second" ).replaceWith
                    
                   // 
                },
                error: function(jqXHR, exception) {
                    
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'preview-hvut-invoice');
                }
            });
        },
        print() {
            var self = this;
            self.loading = true;
            var content = document.getElementById('print_content').innerHTML;
            console.log(content);
            var link = window.open(content, '_blank');
            link.document.write(content);
            link.document.close();
            self.loading = false;
            link.print();
            link.close();

        }

    }    
}
</script>




// WEBPACK FOOTER //
// src/components/invoice/HvutInvoiceView.vue